import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { Address, Order } from 'depoto-core/src/entities'
import { prepareOrderAddressForSave } from '../../../utils'

@Component({
  selector: 'app-order-customer',
  templateUrl: './order-customer.component.html',
  styleUrls: ['./order-customer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderCustomerComponent {
  @Input() canCreateOrEdit = false
  @Input() readonly = false
  @Input() isCreating = false
  @Input() order: Order
  @Input() isShippingAddressSameAsInvoice = true
  @Output() isShippingAddressSameAsInvoiceChange: EventEmitter<any> = new EventEmitter()
  @Output() orderChange: EventEmitter<any> = new EventEmitter()
  @Output() recalculatePricesByPriceLevel: EventEmitter<void> = new EventEmitter()
  @Output() editedAddressChange: EventEmitter<boolean> = new EventEmitter()

  public onRecalculatedPricesByPriceLevel() {
    this.recalculatePricesByPriceLevel.emit()
  }

  isEditedAddress() {
    this.editedAddressChange.emit(true)
  }

  onEditedAddress(address: Address, isBilling: boolean) {
    const orderAddress = prepareOrderAddressForSave(address, isBilling)
    if (isBilling) {
      this.order.invoiceAddress = orderAddress
    } else {
      this.order.shippingAddress = orderAddress
    }
    this.orderChange.emit(this.order)
    this.editedAddressChange.emit(true)
  }

  public relationInvoiceShippingChanged(value: boolean) {
    this.isShippingAddressSameAsInvoiceChange.emit(value)
    this.editedAddressChange.emit(true)
    if (value) {
      this.order.shippingAddress = this.order.invoiceAddress
    } else {
      this.order.shippingAddress = new Address()
      this.orderChange.emit(this.order)
    }
  }
}
